document.addEventListener('DOMContentLoaded', () => {


    document.addEventListener('click', function (e) {
        const el = e.target.closest('.needsclick.kl-teaser-QWi3XF.kl-private-reset-css-Xuajs1');        
        if (el) {
            e.preventDefault();
            // console.log('klaviyoForm triggered!');
            const userType = getUserType();
            const platform = getPlatform();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pop_up_cta_click',
                page_type: getPageType(),
                pop_up_title: "Get 10% off",
                // cta_text: "NA",
                user_id_event: getUserId() || undefined,
                user_type: userType || 'non_logged_in',
                platform: platform
            });
        }
    });


    // Define the handler once so it can be removed
function popupFormClickHandler(e) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'pop_up_form_field',
        page_type: getPageType(),
        pop_up_title: "Unlock Additional 10% off your first order!",
        field_name: "NA",
        cta_text: e.target.innerText.trim(),
        user_id_event: getUserId() || undefined,
        user_type: getUserType() || 'non_logged_in',
        platform: getPlatform()
    });
}

function popupFormFieldHandler(e) {
    console.log("thissss",e);
    if(e.target.value.length > 0){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'pop_up_form_field',
        page_type: getPageType(),
        pop_up_title: "Unlock Additional 10% off your first order!",
        field_name: e.target.getAttribute("aria-label"),
        cta_text: "NA",
        user_id_event: getUserId() || undefined,
        user_type: getUserType() || 'non_logged_in',
        platform: getPlatform()
    });
    }
}

function initPopupFormTracking() {
    const formBtns = document.querySelectorAll(
        '.needsclick.klaviyo-form.klaviyo-form-version-cid_1.go3090125532.kl-private-reset-css-Xuajs1 button'
    );
    formBtns.forEach(btn => {
        // Remove old listener (if it exists)
        btn.removeEventListener("click", popupFormClickHandler);
        // Add new listener
        btn.addEventListener("click", popupFormClickHandler);
    });
    const formInputs = document.querySelectorAll(
        '.needsclick.klaviyo-form.klaviyo-form-version-cid_1.go3090125532.kl-private-reset-css-Xuajs1 :is([type="text"],[type="email"])'
    );
    console.log("formInputs>>>>>>>>>",formInputs);
    formInputs.forEach(btn => {
        // Remove old listener (if it exists)
        btn.removeEventListener("focusout", popupFormFieldHandler);
        // Add new listener
        btn.addEventListener("focusout", popupFormFieldHandler);
    });

}
let checkInterval = setInterval(() => {
    const buttons = document.querySelectorAll(
        '.needsclick.klaviyo-form.klaviyo-form-version-cid_1.go3090125532.kl-private-reset-css-Xuajs1 button'
    );
    if (buttons.length > 0) {
        clearInterval(checkInterval);
        initPopupFormTracking(); 
        console.log('Form tracking initialized.');
    }
    // else {
    //     console.log('Waiting for elements...');
    // }
}, 300); // check every 300ms




    document.querySelectorAll(`[name="sort_by"]`).forEach(select => {
        select.addEventListener("change",function(){
            console.log("select changed");

            let sectionName = document.querySelector(".collection-hero__title")?.innerText || "NA";
            sectionName = sectionName.replace(/\s+/g, " ").trim();

            const pageType = window.location.pathname.includes("/collections/")
                ? "collection_page"
                : window.location.pathname.includes("/products/")
                ? "product_page"
                : "home";

            let activeFilters = [];

            // if (!isReset) {
            const platform =
                /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
                ? "M-web"
                : "D-web";

                document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
                    const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
                    const labelText = input.value;
                    activeFilters.push(`${groupLabel}-${labelText}`);
                });
                let sortSelect = document.querySelector(".facet-filters__sort");
                if(platform == "M-web"){
                    sortSelect = document.querySelector(".mobile-facets__main .mobile-facets__sort select");
                }
                if (sortSelect != "") {
                    const selectedSort = sortSelect.options[sortSelect.selectedIndex].innerText.trim();
                    activeFilters.push(`Sort-${selectedSort}`);
                }
                let priceMin = document.querySelector("input[name='filter.v.price.gte']")?.value;
                let priceMax = document.querySelector("input[name='filter.v.price.lte']")?.value;

                

                if(platform == "M-web"){
                    priceMin = document.querySelector(".mobile-facets__main input[name='filter.v.price.gte']")?.value;
                    priceMax = document.querySelector(".mobile-facets__main input[name='filter.v.price.lte']")?.value;
                }
                if (priceMin || priceMax) {
                    activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
                }
            // }

            const appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";

            const ctaText = "Apply";
            const linkPath = window.location.href || "NA";
            const userId = window.customerId || undefined;
            const userType = userId !== "NA" ? "logged_in" : "guest";

            window.dataLayer.push({
                event: "sort_filter_applied",
                page_type: pageType,
                section_name: sectionName,
                applied_value: appliedValue.replace("Availability-1","Availability-In stock").replace("Availability-0","Availability-Out of stock"),
                cta_text: ctaText,
                link_path: linkPath,
                user_id_event: userId,
                user_status: userType,
                platform,
            });
        });
    });

    document.querySelectorAll(`facet-filters-form .facets__item input[type="checkbox"]`).forEach(filter => {
        filter.addEventListener("change",function(){
            console.log("filter changed!!!");

            let sectionName = document.querySelector(".collection-hero__title")?.innerText || "NA";
            sectionName = sectionName.replace(/\s+/g, " ").trim();

            const pageType = window.location.pathname.includes("/collections/")
                ? "collection_page"
                : window.location.pathname.includes("/products/")
                ? "product_page"
                : "home";
            let activeFilters = [];
            // if (!isReset) {
                document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
                    const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
                    const labelText = input.value;
                    activeFilters.push(`${groupLabel}-${labelText}`);
                });
                const sortSelect = document.querySelector(".facet-filters__sort");
                if (sortSelect) {
                    const selectedSort = sortSelect.options[sortSelect.selectedIndex].innerText.trim();
                    activeFilters.push(`Sort-${selectedSort}`);
                }
                const priceMin = document.querySelector("input[name='filter.v.price.gte']")?.value;
                const priceMax = document.querySelector("input[name='filter.v.price.lte']")?.value;
                if (priceMin || priceMax) {
                    activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
                }
            // }
            const appliedValue = activeFilters.length > 0 ? activeFilters.join("|") : "NA";
            const ctaText = "Apply";
            const linkPath = window.location.href || "NA";
            const userId = window.customerId || undefined;
            const userType = userId !== "NA" ? "logged_in" : "guest";

            const platform =
                /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
                ? "M-web"
                : "D-web";

            window.dataLayer.push({
                event: "sort_filter_applied",
                page_type: pageType,
                section_name: sectionName,
                applied_value: appliedValue.replace("Availability-1","Availability-In stock").replace("Availability-0","Availability-Out of stock"),
                cta_text: ctaText,
                link_path: linkPath,
                user_id_event: userId,
                user_status: userType,
                platform,
            });
        });
    });

    document.querySelectorAll(`.mobile-facets__main button[type="button"][onclick]`).forEach(applyBtn => {
        applyBtn.addEventListener("click",function(){
            console.log("filter apply clicked!!!");

            let sectionName = document.querySelector(".collection-hero__title")?.innerText || "NA";
            sectionName = sectionName.replace(/\s+/g, " ").trim();

            const pageType = window.location.pathname.includes("/collections/")
                ? "collection_page"
                : window.location.pathname.includes("/products/")
                ? "product_page"
                : "home";
            let activeFilters = [];
            // if (!isReset) {
                document.querySelectorAll("facet-filters-form input:checked").forEach((input) => {
                    const groupLabel = input.closest("details")?.querySelector("summary span")?.innerText?.trim() || "Unknown Group";
                    const labelText = input.value;
                    activeFilters.push(`${groupLabel}-${labelText}`);
                });
                const sortSelect = document.querySelector(".mobile-facets__main .mobile-facets__sort select");
                if (sortSelect) {
                    const selectedSort = sortSelect.options[sortSelect.selectedIndex].innerText.trim();
                    activeFilters.push(`Sort-${selectedSort}`);
                }
                const priceMin = document.querySelector(".mobile-facets__main input[name='filter.v.price.gte']")?.value;
                const priceMax = document.querySelector(".mobile-facets__main input[name='filter.v.price.lte']")?.value;
                if (priceMin || priceMax) {
                    activeFilters.push(`Price-${priceMin || "NA"}-${priceMax || "NA"}`);
                }
            // }
            const appliedValue = activeFilters.length > 0 ? activeFilters.join("|"): "NA";
            const ctaText = "Apply";
            const linkPath = window.location.href || "NA";
            const userId = window.customerId || undefined;
            const userType = userId !== "NA" ? "logged_in" : "guest";

            const platform =
                /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
                ? "M-web"
                : "D-web";

            window.dataLayer.push({
                event: "sort_filter_applied",
                page_type: pageType,
                section_name: sectionName,
                applied_value: appliedValue.replace("Availability-1","Availability-In stock").replace("Availability-0","Availability-Out of stock"),
                cta_text: ctaText,
                link_path: linkPath,
                user_id_event: userId,
                user_status: userType,
                platform,
            });
        });
    });

    document.querySelectorAll(`.mobile-facets__main a.mobile-facets__clear`).forEach(applyBtn => {
        applyBtn.addEventListener("click",function(){
            console.log("filter apply clicked!!!");

            let sectionName = document.querySelector(".collection-hero__title")?.innerText || "NA";
            sectionName = sectionName.replace(/\s+/g, " ").trim();

            const pageType = window.location.pathname.includes("/collections/")
                ? "collection_page"
                : window.location.pathname.includes("/products/")
                ? "product_page"
                : "home";
            const linkPath = window.location.href || "NA";
            const userId = window.customerId || undefined;
            const userType = userId !== "NA" ? "logged_in" : "guest";
            const platform =
                /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
                ? "M-web"
                : "D-web";

            window.dataLayer.push({
                event: "sort_filter_applied",
                page_type: pageType,
                section_name: sectionName,
                applied_value: "NA",
                cta_text: "Reset",
                link_path: linkPath,
                user_id_event: userId,
                user_status: userType,
                platform,
            });
        });
    });

    // color interaction
    document.querySelectorAll(`.pillow_colour_and_pattern_products a`).forEach(colorA => {
        colorA.addEventListener("click",function(){
            let src = colorA.querySelector("img").src;
            src = src.split("/");
            let name = src.pop();
            name = name.split(".");
            window.dataLayer.push({
                event: "color_interaction",
                page_type: getPageType(),
                product_name: this.closest(".product__info-wrapper").querySelector(".product__title h1").innerText.trim(),
                color_name: name[0].replace("_150x",""),
                user_id_event: getUserId() || undefined,
                user_status: getUserType() || 'non_logged_in',
                platform: getPlatform()
            });
        });
    });

    // size_interaction
    document.querySelectorAll(`.dropdown-options.dropdown-options-sizes ul li`).forEach(colorA => {
        colorA.addEventListener("click",function(){
            if(localStorage.sizeClicked == undefined || localStorage.sizeClicked == "true"){
            localStorage.sizeClicked = "false";
            console.log("clicked",colorA);
            window.dataLayer.push({
                event: "size_interaction",
                page_type: getPageType(),
                product_name: this.closest(".product__info-wrapper").querySelector(".product__title h1").innerText.trim(),
                size_name: this.querySelector("input").value,
                user_id_event: getUserId() || undefined,
                user_status: getUserType() || 'non_logged_in',
                platform: getPlatform()
            });
            setTimeout(() => {
                localStorage.sizeClicked = "true";
            },1000);
            }
        });
    });

    document.querySelectorAll(`[data-cta_click]`).forEach(ctaBtn => {
        ctaBtn.addEventListener("click",function(){
            window.dataLayer.push({
            event: 'cta_click',
            page_type: getPageType(),
            section_name: this.dataset.cta_click,
            cta_text: this.innerText.trim(),
            platform: getPlatform(),
            link_path: this.href,
            user_id_event: getUserId(),
            user_type_event: getUserType(),
            });
        });
    });

    // console.log("inputtttttttttttt",$(".klaviyo-form-Y2uqWX input"));
    
    // $(".klaviyo-form-Y2uqWX input").on("focusout", function () {
    //     console.log("User left input:", this);
    //     if(this.value.length > 0){            
    //         window.dataLayer.push({
    //         event: 'warranty_interaction',
    //         page_type: getPageType(),
    //         section_name: "Warranty",
    //         field_name: this.closest("div").querySelector("label").innerText.trim(),
    //         cta_text: "Activate Your Warranty Now",
    //         platform: getPlatform(),
    //         user_id_event: getUserId(),
    //         user_type_event: getUserType(),
    //         });
    //     }
    // });

    if(document.body.classList.contains("warranty-new")){
    let checkInputs = setInterval(function () {
        let $inputs = $(".klaviyo-form-Y2uqWX input");
        // console.log("inputs",inputs);
        if ($inputs.length > 0) {
            // console.log("Inputs found! Adding event…");
            $(".klaviyo-form-Y2uqWX").on("focusout", "input", function () {
                console.log("User left input:", this);
                if(this.value.length > 0){
                window.dataLayer.push({
                event: 'warranty_interaction',
                page_type: getPageType(),
                section_name: "Warranty",
                field_name: this.closest("div").querySelector("label").innerText.trim(),
                cta_text: "NA",
                platform: getPlatform(),
                user_id_event: getUserId(),
                user_type_event: getUserType(),
                });
                }
            });
            console.log("aaaaa",$(".klaviyo-form-Y2uqWX button[type='button']"));
            $(".klaviyo-form-Y2uqWX button[type='button']").on("click", function () {
                console.log("User left input:", this);
                window.dataLayer.push({
                event: 'warranty_interaction',
                page_type: getPageType(),
                section_name: "Warranty",
                field_name: "NA",
                cta_text: "Activate Your Warranty Now",
                platform: getPlatform(),
                user_id_event: getUserId(),
                user_type_event: getUserType(),
                });
            });
            clearInterval(checkInputs);
            // console.log("Interval cleared.");
        }
    }, 300);
    }

    // localStorage.needToFire = document.body.dataset.customerLogin;
    // localStorage.fireCount = document.body.dataset.customerLogin == "false" ? 0 : 1
    if((localStorage.needToFire == "true" || localStorage.needToFire == undefined) && document.body.dataset.customerLogin == "true"){
        if(localStorage.fireCount == undefined || localStorage.fireCount == "0"){
            window.dataLayer.push({
            event: 'login_success',
            page_type: getPageType(),
            platform: getPlatform(),
            user_id_event: getUserId(),
            user_type_event: getUserType(),
            });
            localStorage.fireCount = "1";
            localStorage.needToFire = "false";
        }
    }
    if(localStorage.fireCount == "1" && document.body.dataset.customerLogin == "false"){
        localStorage.fireCount = "0";
        localStorage.needToFire = "true";
    }


});

